module Meevo.Plugins.BlockTypes {
  "use strict";

  /**
  * Main Section of Client 
  */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.BlockType> {
        public increments = [];
        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.BaseClasses.IDataService,
            public durationIncrements,
            protected identityService: Meevo.Components.Common.IIdentityService = null,
            noun: Meevo.Model.NounEnum = null,
            protected $scope: angular.IScope,
            appSettings?: Components.Common.IAppSettings,
            sectionSecurityKey?: string
        ) {
            super(sectionId,
                displayNameContentKey,
                template,
                isPrimarySection,
                handlesOwnCrud,
                baseEndpoint,
                sectionEndpoint,
                loggingService,
                dataService,
                identityService,
                noun,
                appSettings, sectionSecurityKey);
            this.durationIncrements.getIncrements(480, false)
                .then((increments) => {
                    this.increments = increments;
                });
        }

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        public missingField: any = -1;
        public timeoutService: angular.ITimeoutService;
        productivityValue: number;

        createSectionModelInstance(postAdd: (data: any) => any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
                this.setProductivityOptions();
            });
        }

        beforeSetFocusOnField() {
            var that = this;

            this.timeoutService(() => that.setFocusOnField(that.missingField));
        }

        setFocusOnField(field: any) {
            switch (field) {
                default:
                    $("[ng-required='required']:visible:first").focus();
                    break;
            }
        }

        displayProductivityOptions() {
            return (this.appSettings && this.appSettings.APP_BUSINFOSETTINGS.appointmentBookSettings.isProductivityNeutralBlockEnabled);
        }

        setProductivityOptionsAndWatcher() {
            this.setProductivityOptions();
            this.$scope.$watch(() => this.model, (newVal, oldVal) => {
                this.checkProductivityOptionsChange(newVal, oldVal);
            }, true);
        }
        checkProductivityOptionsChange(newVal, oldVal) {
            if (newVal && oldVal && (newVal.isIncludedInProductivity !== oldVal.isIncludedInProductivity || newVal.isProductivityNeutral !== oldVal.isProductivityNeutral)) {
                this.setProductivityOptions();
            }
        }

        setProductivityOptions() {
            if (this.model) {
                if (this.displayProductivityOptions()) {
                    this.productivityValue = (this.model.isProductivityNeutral && this.model.isProductivityNeutral === true ? 2 : (this.model.isIncludedInProductivity ? 1 : 0));
                }
                else {
                    if (this.model.isIncludedInProductivity)
                        this.model.isProductivityNeutral = false;
                }
            }
        }

        setProductivityModelOptions() {
            if (this.productivityValue === 2) {
                this.model.isProductivityNeutral = true;
                this.model.isIncludedInProductivity = false;
            }
            else {
                this.model.isIncludedInProductivity = (this.productivityValue === 1 ? true : false);
                this.model.isProductivityNeutral = false;
            }
        }

        defaultMinutesChanged() {
            this.model.defaultMinutes = this.model.defaultMinutes > 0 ? this.model.defaultMinutes : undefined;
        }
    }
}